import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconType } from '@shared/utils/icons';
import { NavbarMenuItem } from '@shared/utils/menu-items';
import { Subject, takeUntil } from 'rxjs';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[shared-ui-navbars-navbar-item]',
    templateUrl: './navbar-item.component.html',
    styleUrls: ['./navbar-item.component.css'],
    standalone: false
})
export class NavbarItemComponent implements OnInit, OnDestroy {
  @Input() level = 0;
  @Input() item: NavbarMenuItem | undefined;
  @Input() isActive = false;

  public IconType = IconType;

  kidsAreDisplayed = false;

  currentQueryParams: Record<string, number> = {};

  private ngUnsubscribe = new Subject<void>();

  constructor(public router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      this.currentQueryParams = params;
    });
  }

  getLevelClass(level: number): string {
    if (level === 1) {
      return 'nav-second-level';
    }
    if (level === 2) {
      return 'nav-third-level';
    }

    return '';
  }

  onClick(): void {
    if (this.isActive) {
      this.kidsAreDisplayed = !this.kidsAreDisplayed;
    } else {
      this.kidsAreDisplayed = true;
    }
  }

  visibleChildElements(): void {
    this.kidsAreDisplayed = true;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
